import script from "./DashboardSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardSidebar.vue?vue&type=script&setup=true&lang=js"

import "./DashboardSidebar.vue?vue&type=style&index=0&id=42c90af4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42c90af4"]])

export default __exports__